module.exports = __webpack_public_path__ + "static/img/DSC00418.4aba0dc3.jpg";